'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const LendingAreaChart = dynamic(() => import('./charts/LendingAreaChart'), { ssr: false });
const InterestBarChart = dynamic(() => import('./charts/InterestBarChart'), { ssr: false });
const LoanStatusRadial = dynamic(() => import('./charts/LoanStatusRadial'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-4">
      {/* Monthly lending volume — large */}
      <div className="lg:col-span-3 card-elevated p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-base font-semibold text-foreground">Monthly Lending Volume</h2>
            <p className="text-xs text-muted-foreground mt-0.5">Principal disbursed per month (VT)</p>
          </div>
          <span className="text-xs text-muted-foreground font-mono">Aug 2025 – Aug 2026</span>
        </div>
        <LendingAreaChart />
      </div>

      {/* Interest earnings + loan status */}
      <div className="lg:col-span-2 flex flex-col gap-4">
        <div className="card-elevated p-5 flex-1">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h2 className="text-base font-semibold text-foreground">Interest Earnings</h2>
              <p className="text-xs text-muted-foreground mt-0.5">Monthly interest collected (VT)</p>
            </div>
          </div>
          <InterestBarChart />
        </div>

        <div className="card-elevated p-5">
          <div className="mb-3">
            <h2 className="text-base font-semibold text-foreground">Loan Status</h2>
            <p className="text-xs text-muted-foreground mt-0.5">Current portfolio breakdown</p>
          </div>
          <LoanStatusRadial />
        </div>
      </div>
    </div>
  );
}